export default "__VITE_ASSET__DBTv7GGD__"